import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getCobrancasDepositoColumns } from './tanStackColumns';

const CobrancasDepositoTable = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  setPaginationState,
  onCancelarCobranca,
  cancelandoCobranca
}) => {
  const columns = getCobrancasDepositoColumns(onCancelarCobranca, cancelandoCobranca);

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          columns={columns}
          data={data}
          isSortable={true}
          withPagination={true}
          manualPagination={true}
          totalItems={totalRegistros}
          onPaginationChange={setPaginationState}
          controlledPagination={paginationState}
          pageSizeOptions={[50, 100, 150, 200]}
          initialState={{
            pageIndex: paginationState?.pageIndex || 0,
            pageSize: paginationState?.pageSize || 100
          }}
          enableColumnConfig={true}
          columnConfigKey="deposito-cobrancas-columns"
          enableColumnResizing={false}
          enableExportExcel={true}
          exportFileName="deposito-cobrancas"
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default CobrancasDepositoTable;
